import React, { useEffect, useState } from 'react';
import { Button, Tooltip, Select } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
const { Option } = Select;
const AttributeListItem = (props) => {
  const {
    attribute,
    index,
    fields,
    onDetailedFieldsSelect,
    onDelete,
    isStatusAlreadyExists,
  } = props;

  return (
    <>
      <div style={{ display: 'flex', gap: 16, marginTop: 16 }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          Attribute {index + 1}
        </div>

        <div>
          <Select
            placeholder='Select a jira field'
            style={{ width: 250 }}
            value={attribute && attribute.name}
            onSelect={(e) => onDetailedFieldsSelect(e, attribute, index)}
            showSearch
            optionFilterProp='children'
            filterOption={(input, option) => {
              return (
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              );
            }}
          >
            {Object.values(fields)
              .filter((el) => !el.isUsed)
              .map((field) => {
                return (
                  <Option key={field.key} value={field.name}>
                    {field.name}
                  </Option>
                );
              })}
            {!isStatusAlreadyExists && (
              <Option key='status' value='status'>
                Status
              </Option>
            )}
          </Select>
        </div>
        <div>
          <Tooltip title='Delete'>
            <Button
              style={{ border: 'none', opacity: '45%' }}
              onClick={() => onDelete(attribute.name, attribute.key)}
              icon={<DeleteOutlined />}
            />
          </Tooltip>
        </div>
      </div>
    </>
  );
};
export default AttributeListItem;
